var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w960 mgt30"},[_c('el-cascader',{staticStyle:{"width":"100%"},attrs:{"value":_vm.val,"options":_vm.options,"props":_vm.props,"size":"large","filterable":""},on:{"change":_vm.change}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }